import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PensionReserveChartsComponent} from './pension-reserve-charts.component';
import {CommonPipesModule} from '../../../../../lifeislife-front/src/app/commons/pipes/common-pipes.module';
import {PieChartModule} from '@swimlane/ngx-charts';
import {InsuranceSubscriptionItemModule} from '../../insurance/insurance-subscription-item/insurance-subscription-item.module';


@NgModule({
  declarations: [PensionReserveChartsComponent],
  exports: [PensionReserveChartsComponent],
  imports: [
    CommonModule,
    CommonPipesModule,
    PieChartModule,
    InsuranceSubscriptionItemModule,
  ],
})
export class PensionReserveChartsModule {
}
